<template>
	<div class="status-info" v-hammer:panstart="panstart" v-hammer:pan.horizontal="pan" v-hammer:panend="panend">
		<div class="content" v-hammer:tap="close">
			<div class="bg" v-bg="'status-info.png'"></div>
			<div class="name" v-bg="'tooltip-title.png'">
				<ui-text :text="name" :replaces="replaces" />
			</div>
			<div class="text">
				<ui-text class="description" :text="status[lang].description" />
				<ui-text v-if="status_info.value && status_info.value !== 'infinite'" class="description" :text="'effect_duration' | lang" :replaces="replaces" />
			</div>
			<div class="close">x</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import data_status from '@/data/data_status'
import UiText from '@/components/ui/ui-text'

export default {
	name: 'status-info',
	props: {
		status_info: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ]),
		name() {
			if (this.status_info.value && this.status_info.value !== 'infinite') return this.status[this.lang].name + ' ' + this.status_info.value
			return this.status[this.lang].name
		},
		status() {
			return data_status.find((s) => s.slug === this.status_info.slug)
		},
		replaces() {
			let replaces = []
			if (this.status_info.value) {
				replaces.push({ '(X)': '(' + this.status_info.value + ')' })
				replaces.push({ '(s)': this.status_info.value > 1 ? 's' : '' })
			}
			return replaces
		}
	},
	methods: {
		close(e) {
			if (!e || !e.srcEvent.stopped) {
				this.$el.classList.remove('panning')
				this.$el.style.transform = 'translateX(120%)'
				setTimeout(() => {
					this.$store.dispatch('remove_status_info', { status_info: this.status_info })
				}, 250)
			}
		},
		panstart(e) {
			this.$el.classList.add('panning')
		},
		pan(e) {
			let x = e.deltaX
			if (x < 0) x = 0
			this.$el.style.transform = 'translateX(' + x + 'px)'
		},
		panend(e) {
			this.$el.classList.remove('panning')
			if (e.deltaX > (this.$el.clientWidth / 4)) {
				this.close()
			} else
				this.$el.style.transform = ''
		}
	},
	components: { UiText }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

.status-info
	position absolute
	right 0
	top 0
	color #fff
	width 100%
	transition 0.25s easeOutBack
	&:hover
		.close
			transform scale(1.2)
	&:active
		.close
			transform scale(0.9)
	&.panning
		transition none
	&.status-info-enter, &.status-info-leave-to
		transform translateX(20%)
		opacity 0
	.content
		padding 40px
		// transform translateX(24px) rotate(-2deg)
		width 100%
		flex center flex-start 
		text-align left
		// &:before
		// 	content ''
		// 	absolute 0
		// 	background-color #000
		// 	transform translate(-8px, 8px)
		.bg
			absolute 0
			// background url(../../assets/img/status-info-bg.svg)
			background-size 100% 100%
			// background dark center left no-repeat
			// border 4px solid #fff
			border-radius 4px
		.name
			position absolute
			left 50%
			bottom calc(100% - 20px)
			transform translateX(-50%)
			background-size 100% 100%
			width (393px / 2)
			height (84px / 2)
			color dark
			text-align center
			font-size 4rem
			flex center center
		.text
			font-size 4rem
			p
				margin 0 0 12px 0
				&:last-child
					margin 0
			.description
				font-size 2.8rem
				& + .description
					opacity 0.5
		.close
			position absolute
			right 20px
			top 20px
			width 32px
			height 32px
			flex center center
			font-size 6.4rem
			transition 0.15s easeOutQuart
			
		

</style>
